import { Box, Card, Grid, Paper, Tab, Tabs, Typography } from '@mui/material';
import React, { useState } from 'react';
import LocationHistory from './LocationHistory';

const AddressDetails = ({ personalDetails }) => {
    const [tabValue, setTabValue] = useState('one');

    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };
     const getFullName = ()=>{
    if(personalDetails.profile){
      // let fullName = [
      //     personalDetails.profile.firstName,
      //     personalDetails.profile?.middleName || '',
      //     personalDetails.profile.lastName
      //   ].filter(Boolean).join(" ");
      let fullName = `${personalDetails.profile.firstName || ''} ${personalDetails.profile.middleName || ''} ${personalDetails.profile.lastName || ''}`.replace(/\s+/g, ' ').trim();
      return fullName
    }else{
      return ''
    }
  }
    return (
        <Box sx={{ minWidth: "100%", marginBottom: ".5%" }}>
            <Box sx={{ width: '100%' }}>
                <Card sx={{ borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }}>
                    <Tabs
                        value={tabValue}
                        onChange={handleChange}
                        // textColor="secondary"
                        // indicatorColor="secondary"
                        aria-label="secondary tabs example"
                        sx={{
                            p: 0,
                            minHeight: '30px',
                            color: '#3a2bde', // Custom text color
                            '& .MuiTabs-indicator': {
                                backgroundColor: '#3a2bde', // Custom indicator color
                            },
                            // '& .MuiTab-root': {
                            //     color: '#3a2bde', // Custom text color
                            // },
                            //active tab text color
                            '& .Mui-selected': {
                                color: '#3a2bde!important',
                            },

                        }}
                    >

                        <Tab value="one" label="Saved Addresses" sx={{ minHeight: '30px', fontSize: '0.75rem' }} />
                        <Tab value="two" label="Active Location History" sx={{ minHeight: '30px', fontSize: '0.75rem' }} />
                    </Tabs>
                </Card>
                {tabValue === 'one' &&
                    <Grid container spacing={2} sx={{ p: '1%' }}>
                        {personalDetails?.customerAllAddress && personalDetails.customerAllAddress.length > 0 ?
                            personalDetails.customerAllAddress.map((address, index) => (
                                <Grid item xs={12} sm={6} key={index}>
                                    <Paper sx={{ p: '2%', mb: '.5%' }} key={index} >
                                        <Box sx={{ display: 'flex', alignItems: 'center', mb: '1%', gap: '2%' }}>
                                            <Typography fontWeight={'500'} sx={{ fontSize: 'small', color: '#778899',lineHeight:1 }}>{address?.fullName || getFullName()} {address.mobileNumber ? `(${address.mobileNumber})`:''}</Typography>
                                            <Typography variant='caption' sx={{ fontSize: 'xx-small', bgcolor: '#d2d2d2', color: '#696969', textTransform: "uppercase", p: '.5% 1%', lineHeight: 1.3, borderRadius: '.15rem' }}>
                                                {address.addressType == '1' && 'Home'}
                                                {address.addressType == '2' && 'Office'}
                                                {address.addressType == '3' && (address.tagName ||'Other')}
                                                {address.addressType == '4' && 'Family & Friend'}
                                            </Typography>
                                        </Box>
                                        <Typography fontWeight={'500'} sx={{ fontSize: 'small', textTransform: 'capitalize' }}>{address.address}</Typography>
                                    </Paper>
                                </Grid>
                            ))
                            :
                            <Grid item xs={12} sx={{ p: '2%', display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '10rem' }}>
                                <Typography fontWeight={'medium'} sx={{ fontSize: 'small', textTransform: 'capitalize' }}>No Address found</Typography>
                            </Grid>
                        }
                    </Grid>
                }
                {tabValue === 'two' && <LocationHistory />}
            </Box>
        </Box>
    );
}

export default AddressDetails;
